import { render, staticRenderFns } from "./PengajuanMitra.vue?vue&type=template&id=29147f95&"
import script from "./PengajuanMitra.vue?vue&type=script&lang=js&"
export * from "./PengajuanMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports